import {
    OPEN_SAMPLE,
    UPDATE_SAMPLE,
    OPEN_SAMPLE_FORM
} from "../constants/appConstants";

import {openMobileMenu} from './pageActions';
/*
 * action creators
 */
const openSamples = (isOpened) => {
    return { type: OPEN_SAMPLE, payload: isOpened}
};

export const open = (isOpened) => {
    const body = document.body;
    if (isOpened){
        body.classList.add("fix-header");
    }else{
        body.classList.remove("fix-header");
    }
    
    return (dispatch, getState) => {
        dispatch(openSamples(isOpened));
        if (!isOpened){
            document.body.classList.remove("overflow-hidden");
            dispatch(openSamplesForm(false));
            document.getElementById("tidio-chat-iframe").classList.remove("d-none");

        }
        if (isOpened && getState().page.isMobMenuOpen){
            dispatch(openMobileMenu(false));
        }
    };
}

const openSamplesForm = (isFormOpened) => {
    return { type: OPEN_SAMPLE_FORM, payload: isFormOpened}
};

export const openForm = (isFormOpened) => {
    if (isFormOpened){
        document.body.classList.add("overflow-hidden");
        document.getElementById("tidio-chat-iframe").classList.add("d-none");
    }
    return (dispatch) => {
        return dispatch(openSamplesForm(isFormOpened));
    };
}

const updateSampleList = (samples) => {
    return { type: UPDATE_SAMPLE, payload: samples}
};

export const add = (sample) => {
    return (dispatch, getState) => {

        // if no list yet
        if (!getState().samples.list) {
            return dispatch(updateSampleList([sample]));
        }

        // if exceeds 6 dont add
        if(getState().samples.list.length >= 6) return;

        // there is a list before.
        const isSampleFound = (getState().samples.list.filter((s)=> s.id === sample.id).length > 0);
        // add sample to list if not added before
        if(!isSampleFound) {
           
            return dispatch(updateSampleList([...getState().samples.list, sample]));
        }
    };
}

export const del = (sample) => {
    return (dispatch, getState) => {
        const udpatedList = getState().samples.list.filter((s)=> s.id !== sample.id);
        return dispatch(updateSampleList(udpatedList));
    };
}

export const delAll = ()=> {
    return (dispatch) => {
        return dispatch(updateSampleList([]));
    };
}

